module.exports = "<div class=\"row\">\n\n  <div class=\"w-160 left bg-white\">\n    <data-card-dates [dates]=\"dates\"></data-card-dates>\n  </div>\n\n   <div class=\"ml-0 pl-0 left\">\n    <table class=\"ctn-data-card-tbl\">\n        <td><data-card-tbl *ngIf=\"data\" [data]=\"data\"></data-card-tbl></td>\n    </table>\n  </div> \n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/data-cards/data-card/data-card.component.html
// module id = ../../../../../src/app/brds/widgets/data-cards/data-card/data-card.component.html
// module chunks = 10